import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import Select from "react-select";
import { fetchAllData } from "../../helper/ProductAttributeHandling";
import { StitchingOptionSchema } from "../../Schema/Schema";
import { Button } from "reactstrap";
import { selectStyles } from "../../utils/selectStyles";

const AddGroupForm = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [categoryData, setCategoryData] = useState([]);

  useEffect(() => {
    async function fetchData() {
     await fetchAllData("/category", setCategoryData);
    }
    fetchData();
  }, []);

  const initialValues = {
    name: "",
    category_id: null,
    optionfield: [],
  };

  const {
    values,
    errors,
    touched,
    setFieldValue,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useFormik({
    initialValues,
    validationSchema: StitchingOptionSchema,
    onSubmit: async (values) => {
      try {
        const response = editData?.id
          ? await axiosInstance.put(`/stitching-option/${editData?.id}`, values)
          : await axiosInstance.post(`/stitching-option`, values);

        if (response.status === 200) {
          toast.success(response.data.message);
          navigator(`/stitching`);
        }
      } catch (error) {
        toast.error(error?.response.data.message);
      }
    },
  });

  useEffect(() => {
    if (editData && editData?.id) {
      setFieldValue("name", editData?.name);
      setFieldValue("category_id", editData?.category_id);
      setFieldValue("optionfield", editData?.stitchingGroupOption || []);
    }
  }, [editData, setFieldValue]);

  const addDynamicField = () => {
    const newField = {
      name: "",
      type: "",
      price: 0,
      dispatch_time: "",
      catalogue_price: 0,
      isCustom: false,
      isDefault: false,
    };
    const updatedFields = [...values.optionfield, newField];
    setFieldValue("optionfield", updatedFields);
  };

  const removeDynamicField = async (index, id) => {
    try {
      if (id) {
        const response = await axiosInstance.delete(`/stitching-option/${id}`);
        if (response.status === 200) {
          toast.success(response.data.message);
          const updatedFields = values.optionfield.filter((_, idx) => idx !== index);
          setFieldValue("optionfield", updatedFields);
        } else {
          const updatedFields = values.optionfield.filter((_, idx) => idx !== index);
          setFieldValue("optionfield", updatedFields);
        }
      } else {
        const updatedFields = values.optionfield.filter((_, idx) => idx !== index);
        setFieldValue("optionfield", updatedFields);
      }
    } catch (error) {
      return error;
    }
  };
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mt-5 mx-4">
          <h3 className="page-title">
            {editData?.id ? "Update " : "Add"} Stitching Group
          </h3>
        </div>


        <div className="col-md-12 grid-margin stretch-card">
          <div className="col-md-12  ">
            <div className="card">
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-5">
                      <div className="form-group">
                        <label className="col-form-label">Name</label>
                        <input
                          type="text"
                          className="form-control form-control border border-dark"
                          id="name"
                          name="name"
                          placeholder="Name"
                          value={values.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {touched.name && errors.name && (
                          <small className="text-danger">{errors.name}</small>
                        )}
                      </div>
                    </div>

                    <div className="col-sm-5">
                      <div className="form-group">
                        <label className="col-form-label">
                          Select Categories
                        </label>

                        <Select
                          name="stitching_id"
                          placeholder="Select Categories"
                          options={categoryData.map((item) => ({
                            value: item.id,
                            label: item.name,
                          }))}
                          value={
                            categoryData
                              .map((item) => ({
                                value: item.id,
                                label: item.name,
                              }))
                              .find((option) => option.value === values.category_id) || null
                          }
                          onChange={(selectedOption) => {
                            setFieldValue(
                              "category_id",
                              selectedOption ? selectedOption.value : null
                            );
                          }}
                          styles={selectStyles}
                        />

                        {touched.category_id && errors.category_id && (
                          <small className="text-danger">{errors.category_id}</small>
                        )}
                      </div>
                    </div>

                    <div
                      className="col-sm-2 text-end float-end "
                      style={{
                        marginTop: "40px",
                      }}
                    >
                      <Button
                        type="button"
                        color="primary"
                        onClick={addDynamicField}
                      >
                        Add Field
                      </Button>
                    </div>

{errors.optionfield && typeof errors.optionfield === "string" && (
  <small className="text-danger d-block mt-2">
    {errors.optionfield}
  </small>
)}

                    <div className="mb-3 col-sm-12">
                      {values.optionfield.map((field, index) => (
                        <div key={index} className="row align-items-center mb-2">
                          <div
                            className="col-sm-12 d-flex align-items-center "
                            style={{ marginTop: "10px" }}
                          >
                            <hr
                              className="flex-grow-1"
                              style={{ borderTop: "1px solid rgba(0, 0, 0, 0.3)" }}
                            />
                            <span
                              className="mx-3"
                              style={{
                                padding: "8px",
                                color: "#333",
                              }}
                            >
                              {index + 1}
                            </span>
                            <hr
                              className="flex-grow-1"
                              style={{ borderTop: "1px solid rgba(0, 0, 0, 0.3)" }}
                            />
                          </div>

                          <div className="col-sm-3">
                            <label className="col-form-label">Name</label>
                            <input
                              type="text"
                              className="form-control form-control border border-dark"
                              placeholder="Name"
                              name={`optionfield[${index}].name`}
                              value={field.name}
                              onChange={(e) => {
                                const updatedFields = [...values.optionfield];
                                updatedFields[index].name = e.target.value;
                                setFieldValue("optionfield", updatedFields);
                              }}
                            />
                            {errors.optionfield?.[index]?.name &&
                              touched.optionfield?.[index]?.name && (
                                <small className="text-danger">
                                  {errors.optionfield[index].name}
                                </small>
                              )}
                          </div>
                          <div className="col-sm-3">
                            <label className="col-form-label ">
                              Select Type
                            </label>
                            <select
                              className={`form-control form-control `}
                              value={field.type}
                              onChange={(e) => {
                                const updatedFields = [...values.optionfield];
                                updatedFields[index].type = e.target.value;
                                setFieldValue("optionfield", updatedFields);
                              }}
                              onBlur={handleBlur}
                              name={`optionfield[${index}].type`}
                            >
                              <option value="" disabled>
                                Select Field Type
                              </option>
                              <option value="Redio">Radio</option>
                              <option value="CheckBox">CheckBox</option>
                            </select>
                            {errors.optionfield?.[index]?.type &&
                              touched.optionfield?.[index]?.type && (
                                <small className="text-danger">
                                  {errors.optionfield[index].type}
                                </small>
                              )}
                          </div>

                          <div className="col-sm-3">
                            <label className="col-form-label">
                              Dispatch Time
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm border border-dark"
                              placeholder="Dispatch Time"
                              value={field.dispatch_time}
                              name={`optionfield[${index}].dispatch_time`}
                              onChange={(e) => {
                                const updatedFields = [...values.optionfield];
                                updatedFields[index].dispatch_time = e.target.value;
                                setFieldValue("optionfield", updatedFields);
                              }}
                            />
                            {errors.optionfield?.[index]?.dispatch_time &&
                              touched.optionfield?.[index]?.dispatch_time && (
                                <small className="text-danger">
                                  {errors.optionfield[index].dispatch_time}
                                </small>
                              )}
                          </div>

                          <div className="col-sm-3">
                            <label className="col-form-label ">price</label>
                            <input
                              type="number"
                              className="form-control form-control border border-dark"
                              placeholder="Price"
                              value={field.price}
                              name={`optionfield[${index}].price`}
                              onChange={(e) => {
                                const updatedFields = [...values.optionfield];
                                updatedFields[index].price = Number(e.target.value);
                                setFieldValue("optionfield", updatedFields);
                              }}
                            />

                            {errors.optionfield?.[index]?.price &&
                              touched.optionfield?.[index]?.price && (
                                <small className="text-danger">
                                  {errors.optionfield[index].price}
                                </small>
                              )}
                          </div>

                          <div className="col-sm-3">
                            <label className="col-form-label">
                              Catalogue price
                            </label>
                            <input
                              type="number"
                              className="form-control form-control border border-dark"
                              placeholder="Price"
                              value={field.catalogue_price}
                              name={`optionfield[${index}].catalogue_price`}
                              onChange={(e) => {
                                const updatedFields = [...values.optionfield];
                                updatedFields[index].catalogue_price = Number(e.target.value);
                                setFieldValue("optionfield", updatedFields);
                              }}
                            />

                            {errors.optionfield?.[index]?.catalogue_price &&
                              touched.optionfield?.[index]?.catalogue_price && (
                                <small className="text-danger">
                                  {errors.optionfield[index].catalogue_price}
                                </small>
                              )}
                          </div>

                          <div className="col-sm-3">
                            <div className="custom-control custom-switch mt-4">
                              <input
                                type="checkbox"
                                className="custom-control-input border border-dark"
                                id={`isCustomSwitch-${index}`}
                                name={`optionfield[${index}].isCustom`}
                                checked={field.isCustom}
                                onChange={(e) => {
                                  const updatedFields = [...values.optionfield];
                                  updatedFields[index].isCustom = e.target.checked;
                                  setFieldValue("optionfield", updatedFields);
                                }}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor={`isCustomSwitch-${index}`}
                              >
                                Custom Stitching
                              </label>
                            </div>
                            <div className="custom-control custom-switch ">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id={`isDefault-${index}`}
                                name={`optionfield[${index}].isDefault`}
                                checked={field.isDefault}
                                onChange={(e) => {
                                  const updatedFields = [...values.optionfield];
                                  updatedFields[index].isDefault = e.target.checked;
                                  setFieldValue("optionfield", updatedFields);
                                }}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor={`isDefault-${index}`}
                              >
                                Is Default
                              </label>
                            </div>
                          </div>

                          <div className="col-sm-2">
                            <Button
                              type="button"
                              color="danger"
                              onClick={() => removeDynamicField(index, field.id)}
                            >
                              Remove
                            </Button>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="text-center mt-4 col-12">

                      <Button type="submit" color="primary">
                        {editData?.id ? "Update " : "Add"}
                      </Button>

                      <Link to="/stitching">
                        <Button color="danger" className="ml-3">Cancel</Button>
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div >
      </div >
    </>
  );
};
export default AddGroupForm;
